<template>
  <vx-card no-shadow >
    <div class="vx-row w-full mt-3">
    <div class="vx-col w-1/3">
    <p class="ml-3">Clinica</p>
    </div>
    <div class="vx-col flex w-2/3">
   <v-select style="margin-bottom:10px" class="mr-2 w-full" :options="docClinics" label="title" 
                  v-validate="'required'"  name="clinica" placeholder= "Seleccione una clinica" 
                  :reduce="option => option.id" @input="setSelected"  v-model="eventData.clinic_id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :selectable="option => !(option.meta.zoom_active && option.meta.zoom_active.toLowerCase() == 'false')">
                  <template v-slot:option="option">
                    <img class="mr-2 inline"  :src=" option.meta.type.toLowerCase() == 'virtual' ? 
                      'https://img.icons8.com/ios/24/000000/zoom.png' :
                      'https://img.icons8.com/material-outlined/24/000000/hospital-3.png' "/>
                    <p class="inline"
                      :class="(option.meta.type.toLowerCase() == 'virtual') && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                        ? 'text-danger' : 'text-primary'"
                    >{{ 
                      (option.meta.type.toLowerCase() == 'virtual')
                       && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                      ?  `${option.title} - Sin Activar` : option.title
                    }}</p>
                  </template>
    </v-select>
    </div>
    </div>
    
    <vs-table noDataText="">
      <template slot="thead">
        <vs-th>Día </vs-th>
        <vs-th>Disponibilidad</vs-th>
        <vs-th>Abre</vs-th>
        <vs-th>Cierra</vs-th>
        <vs-th></vs-th>
      </template>

      <template v-for="(day, index, id) in updateClinicDataMeta.weekDays">
        
        <vs-tr :key="index">
          <vs-td>
            <h5>{{ day.name }}</h5>
          </vs-td>

          <vs-td>
            <vs-switch v-model="day.switch" @change="onChangeSwitch(day)">
              <span slot="on">Abierto</span>
              <span slot="off">Cerrado</span>
            </vs-switch>
          </vs-td>

          <vs-td>
            <flat-pickr
              :config="configdateTimePicker1"
              v-model="day.time"
              placeholder="Hora de apertura"
              :disabled="!day.switch"
              :required="day.switch"
              @input="onChangeManually(day)"
            />
          </vs-td>

          <vs-td>
            <flat-pickr
              :config="configdateTimePicker2"
              v-model="day.time2"
              placeholder="Hora de cierre"
              :disabled="!day.switch"
              :required="day.switch"
              @input="onChangeManually(day)"
            />
          </vs-td>
          <vs-td>
            <feather-icon v-if="!day.showLunch" icon="PlusCircleIcon" icon-pack="feather" svgClasses="w-6 h-6 hover: stroke-current" class="ml-2" @click="displayLunch(day)" />
            <feather-icon v-if="day.showLunch" icon="MinusCircleIcon" icon-pack="feather" svgClasses="w-6 h-6 hover: stroke-current" class="ml-2" @click="displayLunch(day)" />
          </vs-td>
          
        
        </vs-tr>
        <transition name="fade" :key="id" :duration="{ enter: 600, leave:0}">
        <vs-tr v-if="day.showLunch" style="background-color:#f5f5f5;">
          <vs-td />
          <vs-td>
            <h6> Hora de almuerzo </h6>
          </vs-td>
          <vs-td>
            <flat-pickr
              :config="configdateTimePickerLunch"
              v-model="day.lunch"
              placeholder="Inicio"
              :disabled="!day.switch"
              :required="day.switch"
              @input="onChangeManually(day)"  
            />
          </vs-td>
          <vs-td>
            <flat-pickr
              :config="configdateTimePickerLunch2"
              v-model="day.lunch2"
              placeholder="Fin"
              :disabled="!day.switch"
              :required="day.switch"
              @input="onChangeManually(day)"
            />
          </vs-td>
          <vs-td />
        </vs-tr>
          
        </transition>
      </template>
    </vs-table>

     <vs-row justify="center" align="center">
        <vs-col  w="12">
            <p class="mt-6">Duración por defecto de las consultas</p>
           <vs-input
              class="mb-3 mt-1"
              style="width: 30%"
              v-model="userMeta.consultationLength"
              placeholder="Duración en Minutos"
            />
        </vs-col>
      </vs-row>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="editClinicAvailability()"
        >Guardar Cambios</vs-button
      >
      <vs-button class="ml-4 mt-2" type="border" color="warning"
        >Reset</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import vSelect from 'vue-select'
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      showLunch: false,
      defaultHours: ["08:00", "16:00"],
      switch1: false,
      userData: {
        id: null,
        first_name: "",
        last_name: "",
        dob: "",
        gender: "",
        phone: [""],
        linkedin: "",
        address: "",
        address_2: "",
        zone: "",
        city: "",
        country: "",
        meta: {},
      },
      updateClinicData: {
        id: null,
        title: "",
        phone: "",
        location: null,
        longitude: null,
        address: "",
        address_2: "",
        zone: "",
        city: "",
        state: null,
        country: "",
        notes: "",
        meta: {},
        created_by: 0
      },
      eventData: {
          eventType: 'consulta',
          title: null,
          notes: null,
          duration: null,
          notification: true,
          date: null,
          timeType: 'normal',
          clinic_id: null,
          patient_id: null,
          doctor_id: null,
          zoom_email: null,
          zoom_jwt: null,
          clinicType: 'presencial',
          hour: ""
      },
      eventDataDef: {
          eventType: 'consulta',
          title: null,
          notes: null,
          duration: null,
          notification: true,
          date: null,
          timeType: 'normal',
          clinic_id: 1,
          patient_id: null,
          doctor_id: null,
          zoom_email: null,
          zoom_jwt: null,
          clinicType: 'presencial',
          hour: ""
        
      },  
      updateClinicDataMeta: {
        type: "presencial",
        weekDays: [
          {
            id: 1,
            name: "Lunes",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 2,
            name: "Martes",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 3,
            name: "Miércoles",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 4,
            name: "Jueves",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 5,
            name: "Viernes",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 6,
            name: "Sábado",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 0,
            name: "Domingo",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          }
        ]
      },
      userMeta: {
        consultationLength: 60,
        weekDays: [
          {
            id: 1,
            name: "Lunes",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 2,
            name: "Martes",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 3,
            name: "Miércoles",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 4,
            name: "Jueves",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 5,
            name: "Viernes",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 6,
            name: "Sábado",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
          {
            id: 0,
            name: "Domingo",
            switch: false,
            time: null,
            time2: null,
            lunch1: null,
            lunch2: null,
            manually: false,
            manually2: false,
            showLunch: false
          },
        ],
      },
      time: null,
      time2: null,
      configdateTimePicker1: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        wrap: true,
        minuteIncrement: 5,
        defaultHour: 8,
      },
      configdateTimePicker2: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        wrap: true,
        minuteIncrement: 5,
        defaultHour: 16,
      },
      configdateTimePickerLunch: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        wrap: true,
        minuteIncrement: 5,
        defaultHour: 13,
      },configdateTimePickerLunch2: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        wrap: true,
        minuteIncrement: 5,
        defaultHour: 14,
      }
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    eventsList (){
      return this.$store.state.events;
    },
    calendarClinics () {
      console.log(this.$store.state.clinics);
      return this.$store.state.clinics
    },

    docClinics () {
      let currentClinics = this.$store.state.clinics;
      // obtener clinicas virtuales de zoom y que esten activas
      var zoomClinics = this.findZoomClinics();

      if (zoomClinics.length > 0){
        return currentClinics;
      } else {
        // si no ha activado 
        let defaultVirtual = new Object();
        defaultVirtual.title = 'Clinica Virtual Zoom',
        defaultVirtual.meta = {"type":"Virtual", "zoom_active":"false"}
        console.log(currentClinics)
        return [defaultVirtual, ...currentClinics];
      }
    },
  },
  methods: {
    setSelected(value) {
      var clinic = this.$store.state.clinics.find( obj => obj.id == value);
      this.updateClinicDataMeta = {
      ...this.updateClinicDataMeta,
      ...JSON.parse(JSON.stringify(clinic.meta)),
    };

      this.updateClinicData.id = clinic.id
      this.updateClinicData.title = clinic.title
      this.updateClinicData.phone = clinic.phone
      this.updateClinicData.location = clinic.location
      this.updateClinicData.longitude = clinic.longitude
      this.updateClinicData.address = clinic.address
      this.updateClinicData.address_2 = clinic.address_2
      this.updateClinicData.zone = clinic.zone
      this.updateClinicData.city = clinic.city
      this.updateClinicData.state = clinic.state
      this.updateClinicData.country = clinic.country
      this.updateClinicData.notes = clinic.notes
      this.updateClinicData.meta = this.updateClinicDataMeta
      this.updateClinicData.created_by = clinic.created_by

    },
    displayLunch (id) {
        id.showLunch = !id.showLunch
        console.log(id.showLunch)
    },
    editUserSettingsAvailability() {
      this.userData.meta = this.userMeta;
      console.log(this.userData.meta);
      
      try {
        // if form have no errors
          this.editting = !this.editting;
          // TODO editUser
          
          this.$store.dispatch("evolugy/updateUser", this.userData);
          this.showAlert(
            "success",
            "Horario Modificado",
            "Disponibilidad actualizada éxitosamente!"
          );
      } catch (error) {
         console.log("errores");
          this.showAlert(
            "danger",
            "Error al editar la disponibilidad del usuario.",
            error.response.data.error
          );
          // form have errors
      }
          
       
         
        
    },
    editClinicAvailability() {
      this.editUserSettingsAvailability();
      this.updateClinicData.meta = this.updateClinicDataMeta;
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.editting = !this.editting;
          // TODO editUser
          
          this.$store.dispatch("updateClinic", this.updateClinicData);
          this.showAlert(
            "success",
            "Horario Modificado",
            "Disponibilidad actualizada éxitosamente!"
          );
        } else {
          console.log("errores");
          this.showAlert(
            "danger",
            "Error al editar la disponibilidad del usuario.",
            error.response.data.error
          );
          // form have errors
        }
      });
    },
    findZoomClinics(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )

          && (obj.meta.zoom_active);

      });
      return zoomClinics
    },
    onChangeSwitch(day) {
      if (day && day.switch) {
        if (!day.time) {
          day.time = this.defaultHours[0];
          day.manually = false;
        }
        if (!day.time2) {
          day.time2 = this.defaultHours[1];
          day.manually2 = false;
        }
      } else {
        if (day) {
          if (!day.manually) {
            day.time = null;
          }
          if (!day.manually2) {
            day.time2 = null;
          }
        }
      }
    },
    onChangeManually(day) {
      if (day && (!day.manually || !day.manually2)) {
        if (day.time && !this.defaultHours.includes(day.time)) {
          day.manually = true;
        }
        if (day.time2 && !this.defaultHours.includes(day.time2)) {
          day.manually2 = true;
        }
      }
    },
    showAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
  },
  components: {
    flatPickr,
    vSelect
  },
  created() {

    this.$store.dispatch('fetchClinics').then(response=>{
        this.$store.state.clinics.forEach((clinic, index, arr) => {
          this.clinicsActive[clinic.id] = true;
        });
      }, error => {
        console.error(error);
      });
    this.userData.id = this.activeUserInfo.id;

    // userMeta
    this.userMeta = {
      ...this.userMeta,
      ...JSON.parse(JSON.stringify(this.activeUserInfo.meta)),
    };
    this.userData.meta = this.userMeta;
    

    // Object data
    this.userData.first_name = this.activeUserInfo.first_name;
    this.userData.last_name = this.activeUserInfo.last_name;
    this.userData.dob = this.activeUserInfo.dob;
    this.userData.gender = this.activeUserInfo.gender;
    this.userData.phone[0] = this.activeUserInfo.phone[0];
    this.userData.linkedin = this.activeUserInfo.linkedin;
    this.userData.address = this.activeUserInfo.address;
    this.userData.address_2 = this.activeUserInfo.address_2;
    this.userData.zone = this.activeUserInfo.zone;
    this.userData.city = this.activeUserInfo.city;
    this.userData.country = this.activeUserInfo.country;


  },
};
</script>
